import { I18nComponente } from "@/types/gerais"

export const MAtividadesComOcorrenciai18n: I18nComponente = {
  "pt-BR": {
   atividadesComOcorrencias: "atividades com ocorrências"
  },
  "es-CO": {
    atividadesComOcorrencias: "actividades con incidentes"
  }
}
